// extracted by mini-css-extract-plugin
module.exports = {"container":"uiButton_container__1tlxB","root":"uiButton_root__1ZoWj","containedPrimary":"uiButton_containedPrimary__20FqN","containedSuccess":"uiButton_containedSuccess__3_cvE","light":"uiButton_light__3Tw1P","label":"uiButton_label__PbNIi","containerForDelete":"uiButton_containerForDelete__1DKGR","contained":"uiButton_contained__wkGMx","sizeSmall":"uiButton_sizeSmall__2y0Xm"};
    if(module.hot) {
      // 1785568533825
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  